// src/services/ticketService.js

import axios from "axios";
import host from "../../../global.jsx";

/**
 * Get the auth token from cookies
 */
const getAuthHeaders = () => {
  const token = sessionStorage.getItem("accessToken");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Fetch all raised tickets
 */
export const fetchTickets = async () => {
  try {
    const response = await axios.get(`${host}/get-raised-tickets`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching tickets:", error);
    throw error; // Re-throw to handle in component
  }
};

export const updateTicketStatus = async (ticketId, remark, resolved = false) => {
  if (!remark?.trim()) {
    throw new Error("Remark is required");
  }

  try {
    await axios.post(
      `${host}/update-ticket-status/${ticketId}/${encodeURIComponent(remark)}?resolved=${resolved}`,
      {},
      {
        headers: getAuthHeaders(),
      }
    );
    // Return fresh data after update (optional but recommended)
    return await fetchTickets();
  } catch (error) {
    console.error("Error updating ticket status:", error);
    throw error;
  }
};